import React from "react";
import PropTypes from "prop-types";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import moment from "moment";
import "moment-timezone";

import "../css/WaitingProductsQueue.css";

const withTooltip = (id, title, child) => (
  <OverlayTrigger placement="top" transition={false} overlay={<Tooltip id={id}>{title}</Tooltip>}>
    {child}
  </OverlayTrigger>
);

// Position de la commande dans la file des manquants : pastille ronde,
// la prochaine que recevra un préparateur en vert.
export const QueuePositionBadge = ({ id, position, title }) => withTooltip(
  `tooltip-queue-${id}`,
  title,
  <span className={"queue-position" + (position === 1 ? " queue-position-next" : "")} aria-label={title}>
    {position}
  </span>
);

QueuePositionBadge.propTypes = {
  id: PropTypes.number.isRequired,
  position: PropTypes.number.isRequired,
  title: PropTypes.string,
};

// Pourquoi aucun préparateur ne recevra la commande : une icône, une raison.
const REASON_ICONS = {
  // il ne manque que des produits ajoutés à l'expédition
  nothing_to_search: "fa-boxes-packing",
  // pas de zone de dépôt
  no_transit_area: "fa-location-dot",
};

export const WaitingReasonIcon = ({ id, reason, title }) => {
  const icon = REASON_ICONS[reason];
  if (!icon) return null;
  return withTooltip(
    `tooltip-queue-${id}`,
    title,
    <i className={"fa-solid queue-reason queue-reason-" + reason.replace(/_/g, "-") + " " + icon} aria-label={title}></i>
  );
};

WaitingReasonIcon.propTypes = {
  id: PropTypes.number.isRequired,
  reason: PropTypes.oneOf(Object.keys(REASON_ICONS)).isRequired,
  title: PropTypes.string,
};

// Dernier préparateur sur la recherche de manquants ; barré s'il en est sorti
// sans la terminer (la commande attend qu'un autre la reprenne).
export const MissingTaker = ({ task }) => {
  const taker = task.missing_taker;
  if (!taker) return null;
  if (!taker.released) return <span>{taker.name}</span>;
  return withTooltip(
    `tooltip-missing-taker-${task.id}`,
    "A quitté l’attente sans la terminer",
    <span className="missing-taker-released" style={{ textDecoration: "line-through", cursor: "help" }}>
      {taker.name}
    </span>
  );
};

MissingTaker.propTypes = {
  task: PropTypes.object.isRequired,
};

// Heure de départ qui classe la file : départ estimé de la tournée, à défaut
// le début du créneau. En rouge à moins de 4 h, comme l'ancienne colonne.
export const DepartureAt = ({ order }) => {
  const estimated = order.estimated_travel_departure_at;
  const at = estimated || order.shipping_time;
  if (!at) return null;
  const departure = moment(at).tz("Europe/Paris");
  const soon = departure.diff(moment(), "hours", true) < 4;
  return (
    <span
      className={"text-nowrap" + (soon ? " text-danger" : "")}
      title={estimated ? "Départ estimé de la tournée" : "Début du créneau (pas de départ estimé)"}
    >
      {departure.format("HH:mm")}{estimated ? "" : " ?"}
    </span>
  );
};

DepartureAt.propTypes = {
  order: PropTypes.object.isRequired,
};
